import { render, staticRenderFns } from "./ThicknessList.vue?vue&type=template&id=001a8ef2&scoped=true&"
import script from "./ThicknessList.vue?vue&type=script&lang=ts&"
export * from "./ThicknessList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001a8ef2",
  null
  
)

export default component.exports